<template>
    <div>
        <div class="form-horizontal" enctype="multipart/form-data" @submit.prevent="store" @keydown="form.errors.clear($event.target.name)">
            <table class="table table-striped">
                <tr>
                   <th>{{ uLang('app.name') }}</th>
                   <th>{{ uLang('app.action') }}</th>
                </tr>
                <tr v-for="blikOpWerk in blikOpWerks">
                    <td>
                        <input type="text" v-if="blikOpWerk.editable" class="form-control" :name="blikOpWerk.value" v-model="form['value'][blikOpWerk.id]">
                        <span v-if="!blikOpWerk.editable">{{ blikOpWerk.value }}</span>
                    </td>
                    <td>
                        <a href="#" @click.prevent="removeBlikOpWerk(blikOpWerk)" class="btn btn-danger" v-if="blikOpWerk.deleteable" :title="uLang('app.delete_document_type')">
                            <i class="fa fa-trash"></i>
                        </a>
                    </td>
                </tr>
            </table>

            <div class="form-group">
                <div class="input-group">
                    <input type="text" class="form-control" name="new" v-model="newBlikOpWerk" placeholder="Type hier uw nieuwe blik op werk" title="Voeg nieuwe blik op werk toe">
                    <span class="input-group-btn">
                        <button type="button" class="btn btn-success" @click="addBlikOpWerk" :disabled="form.busy || ! newBlikOpWerk">{{ uLang('app.add_type', {type: lang('app.blik_op_werk')}) }}</button>
                    </span>
                </div>
            </div>

            <div class="form-group">
                <input :disabled="form.busy" type="button" :value="uLang('app.save_setting')" @click="store()" class="btn btn-brand" />
            </div>
        </div>
    </div>
</template>

<script>
    import Form from '~/Form/Form'
    import { ErrorAlert, SuccessAlert, DestroyAlert } from '~/Swals'

    export default {
        name: 'form-setting-blik-op-werk',
        props: {
            settingId: {
                required: true,
            },
        },
        data() {
            return {
                form: new Form({
                    value: {},
                }),
                newBlikOpWerk: '',
                blikOpWerks: []
            }
        },
        mounted: function () {
            this.retrieveValues();
        },
        methods: {
            async store() {
                this.form['patch']('/api/admin/settings/' + this.settingId)
                    .then(response => {
                        this.setValues(response);
                        new SuccessAlert({ text: this.uLang('app.type_successfully_updated', {type: lang('app.blik_op_werk')})}).show();
                    })
                    .catch(error => {
                        new ErrorAlert({
                            title: uLang('app.oops_something_went_wrong'),
                            text: uLang('app.all_inputs_need_to_be_filled'),
                        }).show();
                    });
            },

            setValues(data) {
                this.form.value = {};

                this.blikOpWerks = data;

                data.forEach(function (blikOpWerk){
                    if(blikOpWerk.editable){
                        this.value[blikOpWerk.id] = blikOpWerk.value;
                    }

                }, this.form);

            },

            async retrieveValues() {
                const { data } = await window.axios.get('/api/admin/settings/' + this.settingId + '/values');

                this.setValues(data);
            },

            addBlikOpWerk() {
                if (this.newBlikOpWerk === '')
                    return;

                this.blikOpWerks.push(
                    {
                        id: this.newBlikOpWerk,
                        value: this.newBlikOpWerk,
                        deleteable: 1,
                        editable: 1
                    }
                );
                this.form.value[this.newBlikOpWerk] = this.newBlikOpWerk;
                this.newBlikOpWerk = '';
            },

            removeBlikOpWerk(BlikOpWerk) {
                new DestroyAlert({ entity: this.lang('app.cost_center') }).show().then(async () => {
                    delete this.form.value[BlikOpWerk.id];

                    this.blikOpWerks = this.blikOpWerks.filter(function (currentBlikOpWerk) {
                        return currentBlikOpWerk.value != BlikOpWerk.value;
                    });
                })
            }
        }
    }
</script>

<style lang="css" scoped>

</style>
